import {DoughChart} from './Base';

export default {
    extends: DoughChart,
    props: {
        data: {
            default: null,
            required: true
        },
        darkMode: {
            type: Boolean,
            required: true
        },
        showLegend: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        this.renderDoughChart();
    },
    watch: {
        darkMode: {
            handler: 'renderDoughChart',
            immediate: false
        }
    },
    methods: {
        renderDoughChart() {
            this.renderChart(
                {
                    labels: this.data.labels,
                    datasets: this.data.dataSets
                },
                {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: this.showLegend,
                        position: 'right',
                        labels: {
                            padding: 20,
                            usePointStyle: true,
                            boxWidth: 20,
                            font: {
                                size: 12
                            }
                        }
                    }
                },
            )
        }
    }
}
